import React from "react";
import SVGArrow from "./Arrow";
import { HeroPanelWrapper, HeroPanelWrapperLink } from "./HeroPanel.styles";
import { prefixStatamicAssetUrl } from "../../../utils/statamicAssets";

const HeroPanel = ({ label, link, icon }) => {
  const Wrapper = link ? HeroPanelWrapperLink : HeroPanelWrapper;

  const iconSrc = icon ? prefixStatamicAssetUrl(icon.permalink || icon.url) : null;
  const iconAlt = icon?.alt || label || "";

  const isExternalLink = (url) =>
    url && (url.startsWith("http://") || url.startsWith("https://"));

  const targetProps = isExternalLink(link)
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};

  return (
    <Wrapper className="panel" href={link ? link : undefined} {...targetProps}>
      {link && (
        <div className="arrow">
          <SVGArrow />
        </div>
      )}
      <div className="icon mb-3">
        {iconSrc && <img src={iconSrc} alt={iconAlt} />}
      </div>
      <div className="text-black poppins font-weight-bold">{label}</div>
    </Wrapper>
  );
};

export default HeroPanel;
